/**
 * @generated SignedSource<<1f44b50f3cb737802008632877601da3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedContentModuleStorytellingHeader_browseContentModule$data = {
  readonly eyeBrowText: string | null;
  readonly storytellingHeaderColor: string | null;
  readonly storytellingHeaderTextColor: string | null;
  readonly subtitle: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "SbSharedContentModuleStorytellingHeader_browseContentModule";
};
export type SbSharedContentModuleStorytellingHeader_browseContentModule$key = {
  readonly " $data"?: SbSharedContentModuleStorytellingHeader_browseContentModule$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleStorytellingHeader_browseContentModule">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedContentModuleStorytellingHeader_browseContentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "eyeBrowText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storytellingHeaderColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "storytellingHeaderTextColor",
      "storageKey": null
    }
  ],
  "type": "ContentModuleStorytelling",
  "abstractKey": null
};

(node as any).hash = "cfcf3c8e7cb5992a9cc3d2410f27eb50";

export default node;
